<template>
    <v-container fill-height fluid pa-0>
        <v-window style="width: 100%;" v-model="step">
            <v-window-item value="mobile">
                <v-row :style="{ 'min-height': 570+'px' }" align="center" justify="center" no-gutters>
                    <v-col lg="4" md="4" sm="6" xl="3" xs="12">
                        <verify-mobile :errors="[error]"
                                       :is-token-login="tokenLogin"
                                       :loading="loading"
                                       :page-translation-text="translationText.verifyMobilePageText"
                                       :register="register"
                                       :value="loginDetails"
                                       @back="$emit('back')"
                                       @country="loginDetails.country = $event; error = null"
                                       @login="login($event)"
                                       @logout="logout()"
                                       @optionChanged="optionChanged()"
                                       @mobile="loginDetails.mobile = $event; error = null"
                                       @goto="step = $event"
                        ></verify-mobile>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="email">
                <v-row :style="{ 'min-height': 570+'px' }" align="center" justify="center" no-gutters>
                    <v-col lg="4" md="4" sm="6" xl="3" xs="12">
                        <verify-email
                            v-if="step==='email'"
                            :errors="[error]"
                            :is-token-login="tokenLogin"
                            :loading="loading"
                            :page-translation-text="translationText.verifyEmailPageText"
                            :register="register"
                            :value="loginDetails"
                            @back="step='mobile'; loginDetails.email=''"
                            @email="loginDetails.email = $event; error = null"
                            @login="loginEmail($event)"
                            @logout="logout()"
                        ></verify-email>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="loader">
                <v-row :style="{ 'min-height': 570+'px' }" align="center" justify="center" no-gutters>
                    <v-col cols="12">
                        <verify-loader :details="loginDetails"
                                       :page-translation-text="translationText.verifyLoaderPageText"
                                       @done="step = 'otp'"
                                       v-if="step === 'loader'"
                        ></verify-loader>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="otp">
                <v-row :style="{ 'min-height': 570+'px' }" align="center" justify="center">
                    <v-col lg="4" md="6" sm="7" xl="3" xs="12">
                        <otp :errors="[error]"
                             :is-token-login="tokenLogin"
                             :loading="otpLoading"
                             :mobile="loginDetails"
                             :email="loginDetails.email"
                             :page-translation-text="translationText.otpPageText"
                             @back="otpBack()"
                             @clear="error = null"
                             @edit="otpBack()"
                             @resend="$event==='email' ? loginEmail($event) : login($event)"
                             @submit="verify($event)"
                             @email="step='email'"
                             ref="otp"
                        ></otp>
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window>
    </v-container>
</template>

<script>
    import store from '../../store'
    import VerifyMobile from "../../components/auth/VerifyMobile";
    import VerifyEmail from "./VerifyEmail";
    import Otp from "../../components/auth/Otp";
    import VerifyLoader from "../../components/auth/VerifyLoader";

    export default {
        name: "VerificationProcess",
        components: {
            VerifyMobile,
            VerifyEmail,
            Otp,
            VerifyLoader
        },
        props: {
            translationText: {
                required: true,
                type: Object
            },
            mobileDispatch: {
                required: true,
                type: String
            },
            emailDispatch: {
                required: true,
                type: String
            },
            otpDispatch: {
                required: true,
                type: String
            },
            register: {
                type: Boolean,
                default: false
            },
            tokenLogin: {
                type: Boolean,
                default: false
            }
        },
        beforeRouteEnter(to, from, next) {
            //Only show this component if an assessmenttoken is not present
            if (store.state.auth.assessmenttoken) {
                next(false);
            } else {
                next();
            }
        },
        data: () => ({
            error: null,
            step: 'mobile',
            loginDetails: {
                mobile: '',
                email: '',
                country: {},
                via: 'sms'
            },
            mobileVerificationFormIsValid: false,
            loading: false,
            otpLoading: false,
        }),
        methods: {
            // setLoginDetails(event) {
            //     if (event.type === 'country') {
            //         this.$set(this.loginDetails, 'country', event.value);
            //     } else if (event.type === 'mobile') {
            //         this.$set(this.loginDetails, 'mobile', event.value);
            //     }
            // },
            login(event) {
                this.error = null;
                this.loading = true;
                this.$set(this.loginDetails, 'via', event);
                if (this.tokenLogin) {
                    if(event === 'email') {
                        this.$set(this.loginDetails, 'email', this.$store.state.auth.maskedEmail);
                    }
                    this.$store.dispatch(`${this.mobileDispatch}`, this.loginDetails.via).then(() => {
                        this.error = null;
                        this.step = 'loader';
                        this.loading = false;
                    }).catch((error) => {
                        if (error.status === 422) {
                            this.error = this.$t('errors.general.validation_failed');
                        } else {
                            this.error = this.$t('errors.' + error.message);
                        }
                        this.loading = false;
                    })
                } else {
                    this.$store.dispatch(`${this.mobileDispatch}`, {
                        mobile: this.loginDetails.mobile,
                        mobilecountry: this.loginDetails.country.countrycode,
                        via: this.loginDetails.via
                    }).then(() => {
                        this.error = null;
                        this.step = 'loader';
                        this.loading = false;
                    }).catch((error) => {
                        if (error.status === 422) {
                            this.error = this.$t('errors.general.validation_failed');
                        } else {
                            this.error = this.$t('errors.' + error.message);
                        }
                        this.loading = false;
                    })
                }
            },
            loginEmail(event) {
                this.error = null;
                this.loading = true;
                this.$set(this.loginDetails, 'via', event);
                if (this.tokenLogin) {
                    this.$store.dispatch(`${this.emailDispatch}`, this.loginDetails.via).then(() => {
                        this.error = null;
                        this.step = 'loader';
                        this.loading = false;
                    }).catch((error) => {
                        if (error.status === 422) {
                            this.error = this.$t('errors.general.validation_failed');
                        } else {
                            this.error = this.$t('errors.' + error.message);
                        }
                        this.loading = false;
                    })
                } else {
                    this.$store.dispatch(`${this.emailDispatch}`, {
                        email: this.loginDetails.email,
                    }).then(() => {
                        this.error = null;
                        this.step = 'loader';
                        this.loading = false;
                    }).catch((error) => {
                        if (error.status === 422) {
                            this.error = this.$t('errors.general.validation_failed');
                        } else {
                            this.error = this.$t('errors.' + error.message);
                        }
                        this.loading = false;
                    })
                }
            },
            logout() {
                this.$store.dispatch('auth/logout', {
                    clearAssessmenttoken: true,
                    navigate: true
                });
            },
            verify(event) {
                this.error = null;
                this.otp = event;
                this.otpLoading = true;
                this.$store.dispatch(`${this.otpDispatch}`, {otp: this.otp})
                    .then(() => {
                        this.error = null;
                        if (this.register) {
                            this.$router.replace('register/info');
                        }
                        this.otpLoading = false;
                    })
                    .catch((error) => {
                        this.$refs.otp.$refs.otpInputs.clearOtp();
                        if (error.status === 422) {
                            this.error = this.$t('errors.general.validation_failed');
                        } else {
                            this.error = this.$t('errors.' + error.message);
                        }
                        this.otpLoading = false;
                    })
            },
            otpBack(){
              this.error = null;
              if(this.loginDetails.email && this.loginDetails.email!==this.$store.state.auth.maskedEmail){
                 this.step='email';
              }else{
                this.step='mobile';
              }
            },
            optionChanged(){
              this.error = null;
            }
        }
    }
</script>

<style scoped>

</style>